// extracted by mini-css-extract-plugin
export default {"tasks":"V2-z","task":"W2-z","svg":"X2-z","text":"Y2-z"};